import { render, staticRenderFns } from "./create-user-info-for-team.html?vue&type=template&id=2a2ec116&scoped=true&external"
import script from "./create-user-info-for-team.js?vue&type=script&lang=js&external"
export * from "./create-user-info-for-team.js?vue&type=script&lang=js&external"
import style0 from "./create-user-info-for-team.scss?vue&type=style&index=0&id=2a2ec116&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2ec116",
  null
  
)

export default component.exports